export var BuiltInOrgIds = {
    MadOrgId: '0e04e533-196b-4244-999e-fe20995fbe5d',
    SchOrgId: 'a833a05b-620e-4e05-891c-f906ce29c1a8',
    TkeOrgId: '86830635-f70c-49a3-9a88-ba2a7d05409b',
    VcOrgId: 'd1f20280-cba2-4ef5-a301-dae79c65fadc',
    TsaroOrgId: '935ec00a-2193-4ed7-8dbd-165ad804a6e1',
};
